(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceResumeDeleteController',RaceResumeDeleteController);

    RaceResumeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RaceResume'];

    function RaceResumeDeleteController($uibModalInstance, entity, RaceResume) {
        var vm = this;

        vm.raceResume = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RaceResume.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
